import React, { Fragment, FunctionComponent } from "react";
import { connect, MapStateToProps } from "react-redux";

import { Divider } from "@multiweb/reactComponents";
import { IAppState } from "@multiweb/types/react";
import { getTransitionByIndex } from "../../selectors";
import { ITransition, WorkflowEditorProps } from "../../types";
import { TransitionActionsContainer, TransitionPropertiesContainer } from "./containers";

type TransitionPropertyPanelComponentProps = {
    readonly transition: ITransition;
} & WorkflowEditorProps;

const TransitionPropertyPanelComponent: FunctionComponent<TransitionPropertyPanelComponentProps> = ({ hostKey, transition }) => {
    const { actions, picassoIndex } = transition;

    return (
        <Fragment>
            <TransitionPropertiesContainer {...{ picassoIndex, hostKey, transition }} />
            <Divider />
            <TransitionActionsContainer {...{ picassoIndex, hostKey, actions }} />
        </Fragment>
    );
};

type TransitionPropertyPanelProps = {
    readonly picassoLinkId: number;
} & WorkflowEditorProps;

type StateProps = Pick<TransitionPropertyPanelComponentProps, "transition">;

const mapStateToProps: MapStateToProps<StateProps, TransitionPropertyPanelProps, IAppState> = (state, { hostKey, picassoLinkId }) => ({
    transition: getTransitionByIndex(state, hostKey, picassoLinkId),
});

export const TransitionPropertyPanel = connect(mapStateToProps)(TransitionPropertyPanelComponent);
